import { createStore } from 'vuex'

export default createStore({
  state: {
    adviceCode: '',
  },
  mutations: {
    changeAdviceCode (state, advice) {
      state.adviceCode = advice
    }
  },
  actions: {
  },
  modules: {
  }
})
